import { Stripe } from "@stripe/stripe-js";
import { initNewPurchaseSessionPayload, IntentCreationResponse, IntentCreationSubscriptionResponse, PendingPurchaseSession, ProductWithPrice, PurchaseSession, StripeCustomer, StripeCustomerBillingData, StripeCustomerBillingDataPayload, StripeIntentPayload, StripeIntentResponse } from "../../types/stripe";
//import { createSubscription, retrieveStripePaymentIntent, retrieveStripeProduct, retrieveStripeSubscription } from "./stripe_server_temp";
import { StripeElements } from "@stripe/stripe-js/dist";
import { brkRef } from "../../helpers/utils";
import { callCloudFunction } from "./firebase";
import { CREATE_STRIPE_CUSTOMER_CLOD_FUNCTION, CREATE_STRIPE_INTENT, FETCH_STRIPE_PRODUCTS_CLOUD_FUNCTIONS, FINALIZE_STRIPE_PAYMENT_METHOD_CREATION, GET_USER_PAYMENT_METHODS, INIT_NEW_PURCHASE_SESSION, INTERRUPT_SUBSCRIPTION_RENEWAL_CLOUD_FUNCTION, LOAD_CUSTOMER_TRANSACTIONS_CLOUD_FUNCTION, PURCHASE_STRIPE_SUBSCRIPTION_CLOUD_FUNCTION, RETRY_PAYMENT_CLOUD_FUNCTION, SCHEDULE_SUBSCRIPTION_UPDATE_CLOUD_FUNCTION, UPDATE_CUSTOMER_BILLING_DATA, UPDATE_STRIPE_CUSTOMER_CLOUD_FUNCTION } from "../../constants/cloudFunctions";
import { DetachUserPaymenthMethodsPayload, DetachUserPaymenthMethodsReponse, GetUserPaymenthMethodsPayload, GetUserPaymenthMethodsRepsonse, GetUserPaymenthMethodsRepsonseArray, IScheduleSubscriptionUdpdateCloudFunctionPayload, IUpdateStripeCustomerCloudFunctionPayload } from "../../types/cloudFunctions";
import { STRIPE_GENERIC_PAYMENT_ERROR_DESCRIPTION, STRIPE_PAYMENT_ERRORS } from "../../constants/errorDescriptions";

/* export async function elaboratePaymentData(
  customerId: string,
  product: ProductWithPrice
): Promise<IntentCreationResponse> {
  const subscription = await createSubscription(customerId, product.default_price.id);
  const subscriptionIntent = subscription.latest_invoice.payment_intent;
  const _subscription = brkRef(subscription);
  return {
    intent: subscriptionIntent,
    subscriptionData: _subscription,
  };
} */

// TODO: Capire bene quali sono gli scenari che determinano una sessione di pagamento come non valida e scrivere due righe di documentazione
/* export async function restorePurchaseSession(
  pendingSession: PendingPurchaseSession,
  customerId: string,
): Promise<PurchaseSession> {
  const sessionIntent = await retrieveStripePaymentIntent(pendingSession.paymentIntentId);
  console.log('✅FETCHED SESSION INTENT', sessionIntent);
  const sessionProduct = await retrieveStripeProduct(pendingSession.productId);
  console.log('✅FETCHED SESSION PRODUCT', sessionProduct);
  // Controllare la validità attuale della sessione in pending (potrebbe non essere più valida)
  //  a. Se VALIDA -> recuperare i dati da stripe e fare diventare la sessione in pending la nuova sessione corrente
  //  b. Se INVALIDA -> inizializzare una nuova sessione di pagamento e sovrascrivere quella in pending (scritture atomiche con batch) 
  const sessionSubscription = await retrieveStripeSubscription(pendingSession.subscriptionId);
  if (sessionSubscription.status !== 'incomplete') { // non più valida -> (VEDI TODO⬆)
    console.log('❌SESSION NON PIU VALIDA -> sub status:', sessionSubscription.status);
    // inizializzare una nuova sessione
    const newSession = await initNewPurchaseSession(sessionProduct, customerId);
    console.log('✅CREATA NUOVA SESSIONE', newSession);
    return newSession;
  } else {
    console.log('✅SESSIONE ANCORA VALIDA -> returning');
    return {
      product: sessionProduct,
      paymentIntent: sessionSubscription.latest_invoice.payment_intent,
      subscription: sessionSubscription,
    }
  }
} */

/* export async function initNewPurchaseSession(
  product: ProductWithPrice,
  customerId: string,
): Promise<PurchaseSession> {
  const paymentData = await elaboratePaymentData(customerId, product);
  return {
    paymentIntent: paymentData.intent,
    subscription: paymentData.subscriptionData,
    product: product,
  }
} */

export function generateNewPendingPurchaseSessionObj(
  purchaseSession: PurchaseSession
): PendingPurchaseSession {
  return {
    paymentIntentId: purchaseSession.paymentIntent.id,
    subscriptionId: purchaseSession.subscription.id,
    productId: purchaseSession.product.id
  }
}

export async function updateStripeCustomerBillingData(
  customerId: string,
  billingData: StripeCustomerBillingData,
): Promise<StripeCustomer> {
  const payload: IUpdateStripeCustomerCloudFunctionPayload = { stripeCustomerId: customerId, data: billingData }
  const cfResponse = await callCloudFunction(UPDATE_STRIPE_CUSTOMER_CLOUD_FUNCTION, payload);
  if (!(cfResponse.data as any).outcome) throw `[CF ERROR]: ${(!cfResponse.data as any).description}`;
  return (cfResponse.data as any)?.data as StripeCustomer
}

export async function processPayment(
  stripe: Stripe,
  elements: StripeElements,
  returnUrl?: string,
) {
  return stripe.confirmPayment({
    elements: elements,
    confirmParams: {
      //return_url: returnUrl ?? 'http://localhost:3000/purchase/success'
    },
    redirect: 'if_required',
  })
}

export async function processCardPayment(
  stripe: Stripe,
  client_secret: string
) {
  return stripe.confirmCardPayment(client_secret); 
}

export async function getFirstPaymentMehod(
  customerId: string,
):Promise<GetUserPaymenthMethodsRepsonse> {
  const payload: GetUserPaymenthMethodsPayload = {customerId}
  const cfResponse = await callCloudFunction(GET_USER_PAYMENT_METHODS, payload);
  if (!(cfResponse.data as any).outcome) throw `[CF ERROR]: ${(!cfResponse.data as any).description}`;
  return (cfResponse.data as any)?.data.data[0] as GetUserPaymenthMethodsRepsonse
}
export async function getPaymentMehods(
  customerId: string,
): Promise<GetUserPaymenthMethodsRepsonseArray> {
  const payload: GetUserPaymenthMethodsPayload = {customerId}
  const cfResponse = await callCloudFunction(GET_USER_PAYMENT_METHODS, payload);
  if (!(cfResponse.data as any).outcome) throw `[CF ERROR]: ${(!cfResponse.data as any).description}`;
  return (cfResponse.data as  GetUserPaymenthMethodsRepsonseArray)
}

export async function finalizeStripePaymentMethodCreation(
  newCardId: string,
  customerId:string,
): Promise<DetachUserPaymenthMethodsReponse>{
  const payload: DetachUserPaymenthMethodsPayload = {newCardId,customerId}
  const cfResponse = await callCloudFunction(FINALIZE_STRIPE_PAYMENT_METHOD_CREATION, payload);
  console.log("cf response",cfResponse)
  if (!(cfResponse.data as any).outcome) throw `[CF ERROR]: ${(!cfResponse.data as any).description}`;
  return (cfResponse.data as DetachUserPaymenthMethodsReponse)
}

export async function upgradeDowngradeSubscription(
  newPriceId: string,
  subscriptionId: string
): Promise<void> {
  const payload: IScheduleSubscriptionUdpdateCloudFunctionPayload = { newPriceId, subscriptionId };
  const cfRes = await callCloudFunction(SCHEDULE_SUBSCRIPTION_UPDATE_CLOUD_FUNCTION, payload);
  console.log('cfRes', cfRes);
  if (!(cfRes.data as any).outcome) throw `[CF ERROR]: ${(!cfRes.data as any).description}`;
} 

export async function updateCustomerData(
  payload:  StripeCustomerBillingDataPayload,
):Promise<StripeCustomer>{
  const cfResponse = await callCloudFunction(UPDATE_CUSTOMER_BILLING_DATA, payload);
  if (!(cfResponse.data as any).outcome) throw `[CF ERROR]: ${(!cfResponse.data as any).description}`;
  const tempData=cfResponse.data as any
  return tempData.data as StripeCustomer
}

export function getStripePaymentErrorDescription(
  errorCode: string | null
): string {
  if (!errorCode) return STRIPE_GENERIC_PAYMENT_ERROR_DESCRIPTION;
  return STRIPE_PAYMENT_ERRORS[errorCode] ?? STRIPE_GENERIC_PAYMENT_ERROR_DESCRIPTION;
}

export function doesStripePaymentErrorRequireRetry(
  code: string | null
): boolean {
  return true;
}

export async function getClientSecretFromStripeIntent(
  payload:  StripeIntentPayload,
):Promise<StripeIntentResponse>{
  const cfResponse = await callCloudFunction(CREATE_STRIPE_INTENT, payload);
  if (!(cfResponse.data as any).outcome) throw `[CF ERROR]: ${(!cfResponse.data as any).description}`;
  return cfResponse.data as StripeIntentResponse
}
export async function initPurchaseSessionCF(
  payload:  initNewPurchaseSessionPayload,
):Promise<PurchaseSession>{
  const cfResponse = await callCloudFunction(INIT_NEW_PURCHASE_SESSION, payload);
  if (!(cfResponse.data as any).outcome) throw `[CF ERROR]: ${(!cfResponse.data as any).description}`;
  return (cfResponse.data as any).data as PurchaseSession
}

export async function retryStripePayment() {
  const cfResponse = await callCloudFunction(RETRY_PAYMENT_CLOUD_FUNCTION, null);
  if (!(cfResponse.data as any).outcome) throw `[CF ERROR]: ${(!cfResponse.data as any).description}`;
  return (cfResponse.data as any).data as any;
}

export async function getUserTransactions(
  cursors: { startAfter: string | null; endBefore: string | null, size?: number }
): Promise<any> {
  const payload = {startingAfterCursor: cursors.startAfter, endingBeforeCursor: cursors.endBefore, size: cursors.size};
  const cfResponse = await callCloudFunction(LOAD_CUSTOMER_TRANSACTIONS_CLOUD_FUNCTION, payload);
  if (!(cfResponse.data as any).outcome) throw `[CF ERROR]: ${(!cfResponse.data as any).description}`;
  return (cfResponse.data as any).data as any;
}

export async function interruptSubscriptionRenewal() {
  const cfResponse = await callCloudFunction(INTERRUPT_SUBSCRIPTION_RENEWAL_CLOUD_FUNCTION, null);
  if (!(cfResponse.data as any).outcome) throw `[CF ERROR]: ${(!cfResponse.data as any).description}`;
  return (cfResponse.data as any).data as any;
}

export async function purchaseStripeSubscription(
  priceId: string
) {
  const payload = { priceId };
  const cfResponse = await callCloudFunction(PURCHASE_STRIPE_SUBSCRIPTION_CLOUD_FUNCTION, payload);
  if (!(cfResponse.data as any).outcome) throw `[CF ERROR]: ${(!cfResponse.data as any).description}`;
  return (cfResponse.data as any).data as any;
}

export async function retrieveStripeProducts() {
  const cfResponse = await callCloudFunction(FETCH_STRIPE_PRODUCTS_CLOUD_FUNCTIONS, null);
  if (!(cfResponse.data as any).outcome) throw `[CF ERROR]: ${(!cfResponse.data as any).description}`;
  return (cfResponse.data as any).data as any;
}

export async function createStripeCustomer(
  name: string,
  email: string
) {
  const cfResponse = await callCloudFunction(CREATE_STRIPE_CUSTOMER_CLOD_FUNCTION, {name, email});
  if (!(cfResponse.data as any).outcome) throw `[CF ERROR]: ${(!cfResponse.data as any).description}`;
  return (cfResponse.data as any).data as any;
}